exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* 原点样式 */\n.signStyle[data-v-0e37abc8] {\n  margin-top: 10px;\n  width: 21px;\n  height: 21px;\n  border-radius: 50%;\n  background-color: red;\n  color: aliceblue;\n  position: absolute;\n  text-align: center;\n  line-height: 21px;\n  left: 160px;\n}\n", ""]);

// exports
